import React, { useState, Fragment } from 'react';
import PropTypes from 'prop-types';
import { Button, Close } from 'chaoskit/src/components';
import { directoryUrl } from 'chaoskit/src/helpers/utility';
import Cookies from 'js-cookie';
import useSize from 'react-use/lib/useSize';
import { Helmet } from 'react-helmet';

import { Data } from '../components';

const cookieKey = 'gremlin-announcementBar-hidden';
const cookieValue = Cookies.get(cookieKey);

const AnnouncementBar = ({ content, button, show, variation }) => {
  const [isVisible, setVisibility] = useState(true);

  // Translate variation
  const getGradientClass = variationOption => {
    switch (variationOption) {
      case 'blue-green':
        return 'u-gradient--blue-green';
      case 'dark-blue':
        return 'u-gradient--darkerBlue-darkestBlue';
      case 'blue-purple':
        return 'u-gradient--darkBlue-purple';
      case 'dark-purple':
        return 'u-gradient--darkPurple';
      default:
        return 'u-gradient--blue-green';
    }
  };

  const setCookie = () => {
    Cookies.set(cookieKey, window.btoa(unescape(encodeURIComponent(content))));

    setVisibility(false);
  };

  const [announcementBar, { height }] = useSize(
    () => (
      <aside
        className={`announcementBar u-contrast ${getGradientClass(variation)}`}
      >
        <Close
          className="announcementBar-close"
          onClick={() => setCookie()}
          title="Hide announcement"
        />
        <div className="announcementBar-content">
          <Data markdown>{content}</Data>
        </div>
        {button.show && (
          <Button
            type="default"
            url={directoryUrl(button.url)}
            size="xsmall"
            rel="noreferrer noopener"
            className="announcementBar-trigger"
          >
            <Data>{button.label}</Data>
          </Button>
        )}
      </aside>
    ),
    { width: 0, height: 0 }
  );

  // Hide if `show` prop is false, the cookie values don't match, or we've updated the state to set the cookie
  if (
    !show ||
    (typeof window !== 'undefined' &&
      window.btoa(unescape(encodeURIComponent(content))) === cookieValue) ||
    !isVisible
  )
    return null;

  return (
    <Fragment>
      <Helmet>
        <style type="text/css">{`
          :root {
            --gremlin__announcementBar-height: ${height}px;
          }
        `}</style>
      </Helmet>
      {announcementBar}
    </Fragment>
  );
};

AnnouncementBar.propTypes = {
  show: PropTypes.bool,
  content: PropTypes.string.isRequired,
  button: PropTypes.shape({
    show: PropTypes.bool.isRequired,
    url: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired,
  }),
  variation: PropTypes.string.isRequired,
};

export default AnnouncementBar;
